import { Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { STATE } from './STATE';
import TrrSelectCustom from './TreeSelectCustom';
import PropTypes from 'prop-types';

const TaskCanceled = ({ disabled, state, department }) => {
    const { t } = useTranslation();
    return (
        <div className="pb-12">
            <div className="font-medium text-xl">{t('Task Canceled')}</div>
            <div className="text-sm text-gray-400">{t('Workflow Step')}</div>
            <div
                className="p-4 mt-4 rounded-md max-w-[504px]"
                style={{
                    border: '1px solid #7B67FB',
                    boxShadow: '0px 2px 12px rgba(123, 103, 251, 0.2)',
                }}
            >
                <Form.Item
                    className="mb-2 w-full"
                    isListField
                    name={['taskCanceled', 'stepName']}
                    label={t('Step Name')}
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Input
                        disabled={disabled}
                        placeholder={t('dataFlow.inputpl')}
                        maxLength={20}
                        showCount
                        size="large"
                        className="pr-12"
                    />
                </Form.Item>
                <Form.Item
                    label={t('State')}
                    className="mb-2 w-full"
                    isListField
                    name={['taskCanceled', 'stateId']}
                    initialValue={STATE.CANCEL_TASK}
                >
                    <Select
                        placeholder={t('Select State')}
                        style={{ width: '100%' }}
                        size="large"
                        disabled
                    >
                        {state?.map((state) => (
                            <Select.Option
                                key={state?.stateId}
                                value={state?.stateId}
                            >
                                {state?.stateName}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    label={t('Step Description')}
                    className="mb-2 w-full"
                    isListField
                    name={['taskCanceled', 'stepDescription']}
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Input.TextArea
                        disabled={disabled}
                        placeholder={t('dataFlow.inputpl')}
                        rows={4}
                        size="large"
                        className="pr-12"
                    />
                </Form.Item>
                <Form.Item
                    label={t('Assign to')}
                    className="mb-2 w-full"
                    isListField
                    name={['taskCanceled', 'assignTo']}
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <TrrSelectCustom
                        disabled={disabled}
                        department={department}
                    />
                </Form.Item>
            </div>
        </div>
    );
};

TaskCanceled.propTypes = {
    disabled: PropTypes.bool,
    state: PropTypes.array,
    department: PropTypes.array,
};

export default TaskCanceled;
